export default "{\n    \"label_one\": \"{{name}}\",\n    \"label_0\": \"Category\",\n    \"label_other\": \"{{count}} Categories\"\n}\n"